import { render, staticRenderFns } from "./ServicePanel.vue?vue&type=template&id=2aa3d9aa&scoped=true&"
import script from "./ServicePanel.vue?vue&type=script&lang=js&"
export * from "./ServicePanel.vue?vue&type=script&lang=js&"
import style0 from "./ServicePanel.vue?vue&type=style&index=0&id=2aa3d9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3d9aa",
  null
  
)

export default component.exports